import {
  IsString,
  IsNotEmpty,
  IsOptional,
  Length,
  IsUUID,
  IsNumberString,
} from 'class-validator';

import {
  REQUIRED_FIELD_VALIDATION_MESSAGE,
  SMS_CODE_LENGTH,
} from '../../auth.constants';

export class LoginAliDto {
  @Length(SMS_CODE_LENGTH, SMS_CODE_LENGTH, {
    message: 'Неверный СМС-код',
    groups: ['form'],
  })
  @IsNumberString(
    {
      no_symbols: true,
    },
    {
      message: 'Неверный СМС-код',
      groups: ['form'],
    },
  )
  @IsNotEmpty({
    groups: ['form'],
    message: 'Вы забыли ввести СМС-код',
  })
  @IsString({
    groups: ['form'],
    message: 'Вы забыли ввести СМС-код',
  })
  code: string;

  @IsOptional()
  @IsUUID()
  @IsString()
  @IsNotEmpty(REQUIRED_FIELD_VALIDATION_MESSAGE)
  passCode?: string;

  @IsOptional()
  @IsUUID()
  @IsString()
  authInstanceId?: string;
}
